import React, { lazy } from 'react'
import { FaRegCircleUser } from 'react-icons/fa6'
import lazyComponent from './lazy'
import Users from 'containers/UMS/Users'
import FraudUsers from 'containers/UMS/FraudUsers'
import { TbUserX } from 'react-icons/tb'
import { TbUser } from 'react-icons/tb'

const Component: React.FC = () => <div>Testing</div>

const UMS = [
  {
    key: 'view_UMS',
    url: 'UMS',
    name: 'App.UMS',
    title: 'Manejo de Usuarios y Soporte',
    redirectTo: 'App.UMS.Users',
    data: {
      nav: {
        type: 'menu',
        sort: 1,
        icon: <FaRegCircleUser />
      }
    }
  },
  {
    key: 'view_UMS_Users',
    url: '/users',
    name: 'App.UMS.Users',
    title: 'Usuarios',
    views: {
      'main@App': { component: lazyComponent(Users) }
    },
    data: {
      nav: {
        type: 'menu',
        sort: 1,
        icon: <TbUser />
      }
    }
  },
  {
    key: 'view_applet_campaigns',
    url: '/fraud-users',
    name: 'App.UMS.FraudUsers',
    title: 'Usuarios Fraudulentos',
    views: {
      'main@App': { component: lazyComponent(FraudUsers) }
    },
    data: {
      nav: {
        type: 'menu',
        sort: 2,
        icon: <TbUserX />
      }
    }
  }
]

export default UMS
